const MARKET_BIAS_LABELS = {
  STRONG_BULLISH: "Strong Bullish",
  BULLISH: "Bullish",
  NEUTRAL_POSITIVE: "Neutral to Positive",
  NEUTRAL: "Neutral",
  NEUTRAL_NEGATIVE: "Neutral to Negative",
  BEARISH: "Bearish",
  STRONG_BEARISH: "Strong Bearish",
};

const RISK_LEVEL_LABELS = {
  VERY_LOW: "Very Low",
  LOW: "Low",
  LOW_MODERATE: "Low to Moderate",
  MODERATE: "Moderate",
  MODERATE_HIGH: "Moderate to High",
  HIGH: "High",
  VERY_HIGH: "Very High",
};

function fallbackLabel(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function formatMarketBias(value) {
  const key = String(value ?? "").trim().toUpperCase();
  return MARKET_BIAS_LABELS[key] ?? fallbackLabel(value);
}

export function formatRiskLevel(value) {
  const key = String(value ?? "").trim().toUpperCase();
  return RISK_LEVEL_LABELS[key] ?? fallbackLabel(value);
}
